var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMagicEden = function SvgMagicEden(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#MagicEden_svg__a)",
    d: "M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20-8.954 20-20 20S0 31.046 0 20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 23.936c0 1.234.913 2.235 2.04 2.235h6.79c.647 0 1.17-.574 1.17-1.281s-.523-1.28-1.17-1.28h-4.95c-.032 0-.057-.029-.057-.063 0-.018.008-.035.02-.047l2.25-2.068c.363-.335.574-.829.574-1.35 0-.517-.208-1.008-.568-1.343l-2.222-2.068a.065.065 0 0 1-.02-.047c0-.035.026-.062.057-.062h4.917c.646 0 1.169-.574 1.169-1.281 0-.708-.523-1.281-1.17-1.281H20v3.258l2.878 2.722a.145.145 0 0 1 .044.105c0 .04-.017.08-.044.106l-2.171 2.053A2.33 2.33 0 0 0 20 23.936Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.953 14C10.875 14 10 14.958 10 16.14v8.622c0 .778.576 1.409 1.286 1.409.71 0 1.287-.631 1.287-1.41v-6.049c0-.032.024-.059.053-.059.023 0 .043.015.05.038l2.316 6.562c.18.507.624.84 1.12.84.495 0 .94-.332 1.119-.838l2.328-6.56.441-1.437V14c-.634 0-1.205.422-1.442 1.066l-2.359 6.404a.095.095 0 0 1-.088.065.095.095 0 0 1-.088-.065l-2.258-6.13c-.298-.81-1.015-1.34-1.812-1.34Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "MagicEden_svg__a",
    x1: 0,
    x2: 30.645,
    y1: 0,
    y2: 37.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B08B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F42E83"
  })))));
};
export default SvgMagicEden;